import fs from 'node:fs'
import { findNextNonEmptyLine } from '@cli-utils/text.js'

export function cleanEnvFile(envPath: string): string[] {
  if (!fs.existsSync(envPath)) return []

  const content = fs.readFileSync(envPath, 'utf-8')
  const lines = content.split('\n')
  const removed: string[] = []
  const kept: string[] = []

  const headerPattern = /^# =+$/
  const headerTextPattern = /^# BetterStart Admin$/

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i]!
    const trimmed = line.trim()

    if (trimmed.match(/^BETTERSTART_\w+=/)) {
      const key = trimmed.split('=')[0]!
      removed.push(key)
      continue
    }

    if (headerPattern.test(trimmed)) {
      const next = lines[i + 1]?.trim()
      const afterNext = lines[i + 2]?.trim()
      if (next && headerTextPattern.test(next) && afterNext && headerPattern.test(afterNext)) {
        i += 2
        continue
      }
    }

    if (trimmed.startsWith('#') && !headerPattern.test(trimmed)) {
      const nextNonEmpty = findNextNonEmptyLine(lines, i + 1)
      if (nextNonEmpty?.match(/^BETTERSTART_\w+=/)) {
        continue
      }
    }

    kept.push(line)
  }

  if (removed.length === 0) return []

  const result = kept
    .join('\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim()

  if (result === '') {
    fs.unlinkSync(envPath)
  } else {
    fs.writeFileSync(envPath, `${result}\n`, 'utf-8')
  }

  return removed
}
